var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupeeCharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rupees-charge-back (1) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0001 5.7575C10.0001 5.53262 9.8161 5.34863 9.59122 5.34863H6.42254C6.19766 5.34863 6.01367 5.53262 6.01367 5.7575C6.01367 5.98237 6.19766 6.16636 6.42254 6.16636H7.33021C7.6941 6.15818 8.03346 6.3667 8.18882 6.69788H6.42254C6.19766 6.69788 6.01367 6.88187 6.01367 7.10674C6.01367 7.33162 6.19766 7.51561 6.42254 7.51561H8.18882C8.13976 7.60965 8.07434 7.69551 8.00484 7.77319C7.82494 7.949 7.58371 8.04713 7.3343 8.04713H6.42662C6.19766 8.05122 6.01367 8.2393 6.01776 8.46826C6.01776 8.57865 6.06682 8.68496 6.14451 8.76264L8.40961 10.9092C8.56907 11.0686 8.83074 11.0645 8.98611 10.9051C9.14556 10.7456 9.14147 10.484 8.98202 10.3286C8.97793 10.3245 8.97384 10.3204 8.96975 10.3163L7.44469 8.87303C7.874 8.84441 8.27469 8.66451 8.57724 8.35787C8.8103 8.1289 8.97384 7.83452 9.04744 7.51561H9.58714C9.81201 7.51561 9.996 7.33162 9.996 7.10674C9.996 6.88187 9.81201 6.69788 9.58714 6.69788H9.04335C8.99837 6.5098 8.92069 6.3299 8.81438 6.16636H9.58714C9.8161 6.16636 10.0001 5.98237 10.0001 5.7575Z",
    fill: "#7DCC18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.60237 3.7236C4.46427 3.81516 4.27949 3.79426 4.17189 3.66825C4.05638 3.53298 4.07159 3.32742 4.21429 3.22124C5.99771 1.89429 8.68227 1.53089 10.9752 2.72199C13.4185 3.99129 14.4336 6.41332 14.2402 8.45738C14.225 8.61797 14.0868 8.73563 13.9255 8.73563C13.7347 8.73563 13.5854 8.57219 13.5926 8.38152C13.6754 6.18114 12.7759 4.42467 10.6985 3.32193C8.59196 2.20345 6.54039 2.43868 4.60237 3.7236Z",
    fill: "#7DCC18",
    stroke: "#7DCC18",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2282",
    d: "M4.5 2L4 4H6",
    stroke: "#7DCC18",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2283",
    d: "M11.5 14L12 12L10 12",
    stroke: "#7DCC18",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.918 12.6752C11.918 12.6753 11.918 12.6755 11.9178 12.6755C10.1112 14.0943 7.45357 14.4534 5.19625 13.3681C2.86075 12.245 1.64106 9.97334 1.73995 7.7949C1.74756 7.62715 1.88928 7.5 2.0572 7.5C2.24317 7.5 2.39092 7.65527 2.39144 7.84124C2.39741 9.97122 3.32376 11.6555 5.3392 12.7043C7.33492 13.7431 9.28782 13.5693 11.1466 12.4412C11.3599 12.3117 11.6376 12.3476 11.7999 12.5371C11.8386 12.5824 11.878 12.6283 11.9179 12.6748C11.918 12.6749 11.918 12.675 11.918 12.6752Z",
    fill: "#7DCC18",
    stroke: "#7DCC18",
    strokeWidth: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupeeCharge);
export default __webpack_public_path__ + "static/media/rupee-charge.4dfa95d42d28cb57b8d90774074c2b9e.svg";
export { ForwardRef as ReactComponent };